<script>
/*
 *```vue
 *<v-switch :value="value">
 *  <template #option1>
 *    This is shown when value == option1
 *  </template>
 *  <template #option2>
 *    This is shown when value == option2
 *  </template>
 *  <template>
 *    This is shown when value does not match either of the previous template names.
 *    If it is omitted, nothing will be rendered.
 *  </template>
 *</v-switch>
 *```
 */

export default {
  name: 'v-switch',
  functional: true,
  props: {
    value: { required: true },
  },
  render(h, { data, props, scopedSlots }) {
    const { value } = props
    const slotFn = value in scopedSlots ? scopedSlots[value] : scopedSlots.default

    return slotFn ? slotFn(data.attrs) : null
  },
}
</script>
